import { render, staticRenderFns } from "./payrollcodesBulk.vue?vue&type=template&id=5871b676"
import script from "./payrollcodesBulk.vue?vue&type=script&lang=js"
export * from "./payrollcodesBulk.vue?vue&type=script&lang=js"
import style0 from "./payrollcodesBulk.vue?vue&type=style&index=0&id=5871b676&prod&lang=css"
import style1 from "./payrollcodesBulk.vue?vue&type=style&index=1&id=5871b676&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports